import { render, staticRenderFns } from "./StockTiers.vue?vue&type=template&id=27b62364&"
import script from "./StockTiers.vue?vue&type=script&lang=js&"
export * from "./StockTiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports